import type { AutoFormWidgetsProps } from '../autoForm'
import { InputWidget } from './inputWidget'

export function TextWidget(props: AutoFormWidgetsProps) {
  return <InputWidget type="text" {...props} />
}
